import React from 'react';
import { Section } from './ui/Section';
export function PainSection() {
  return <Section className="bg-white" data-id="element-125">
      <div className="text-center mb-12" data-id="element-126">
        <h2 className="text-sm font-bold tracking-widest text-amber uppercase mb-3" data-id="element-127">
          El escenario real
        </h2>
        <h3 className="text-3xl md:text-4xl font-bold text-navy mb-6" data-id="element-128">
          ¿Qué le doy hoy… sin arriesgarme a que mañana amanezca con diarrea?
        </h3>
      </div>

      <div className="prose prose-lg prose-navy mx-auto text-navy/80 leading-relaxed" data-id="element-129">
        <p className="mb-6" data-id="element-130">
          No es el video de TikTok. No es el "antes y después" de alguien con
          cocina perfecta. Es tu casa, tu rutina, tu perro, tu presupuesto.
        </p>

        <p className="mb-6 font-medium text-navy text-xl border-l-4 border-amber pl-6 py-2 bg-amber/5 rounded-r-lg" data-id="element-131">
          Si sigues con croquetas, te quedas con la duda y la culpa. Si cambias
          "de golpe", te arriesgas al caos y al susto.
        </p>

        <p data-id="element-132">
          La mayoría se rinde aquí. No porque no quieran lo mejor para su perro,
          sino porque el miedo a hacerlo mal paraliza. Y es un miedo válido:
          nadie quiere ver a su perro sufrir por una buena intención.
        </p>
      </div>
    </Section>;
}